module.exports = __webpack_public_path__ + "img/看板互联.a7fb850b.gif";